module.exports = "<p>\n  footer-public works!\n</p>\n"